

const searchUtil = {

	// bygger om sökbara modellen utifrån vilka "saker" som är valda, hämtar produkter ur en origin. 
	async rebuildSearchModel(state) {

		console.log('FP: search rebuildSearchModel(), pre CO2:', state.searchModel);

		const start2 = performance.now();

		const start = Date.now();

		const currentSearchModel = state.searchModel;

		var meta = currentSearchModel.meta;

		if (!meta) {
			meta = {};
		}

		meta.created = new Date().toLocaleTimeString()

		currentSearchModel.meta = meta


		meta.origin = [];

		var baseProductList = [];
		currentSearchModel.productList = [];

		// bygger productId listor utifrån kategori, appender alla kategorier i pathen. 
		/*if(state.searchProductConfig?.productGroupKey){

			alert(123);
			const key = state.searchProductConfig?.productGroupKey;
			const productGroup = state.productStore.data.productGroupList?.find(productGroup => productGroup.key == key);

			baseProductList = this.productIdListToProductList(productGroup?.productIdList, state);

			meta.origin.push("ProductGroup-" + key)


		}else */
		if(state.searchProductConfig.category && state.searchProductConfig.category.categoryId > 0){

			const categoryId = state.searchProductConfig.category.categoryId;

			var productIdList = [];

			
			//state.baseModel.categoryModel2.categoryList.forEach(category => {

			const categoryModel = this.getCategoryModel(state.baseModel, state.productTypeModel)

			categoryModel.categoryList.forEach(category => {

				/*const pathIdList = ";" + category.pathIdList + ";"

				if (pathIdList.includes(";" + categoryId + ";")) {
					productIdList = productIdList.concat(category.productList);
				}*/

				//console.log('FP: search storeSearchUtils: categoryId: ', category);
				

				if (category.pathIdList?.includes(categoryId)){

					//console.log('FP: search storeSearchUtils: categoryId: HIT: ', categoryId);
					productIdList = productIdList.concat(category.productList);
				}

			});


			

			baseProductList = this.productIdListToProductList(productIdList, state);

			console.log('FP: search category: baseProductList.length', baseProductList.length);
			meta.origin.push("Category");

			// annars om vi har ett år satt 
		}else if (state.searchProductConfig.year && state.searchProductConfig.year.year != ""){

			state.searchProductConfig.year.productList.forEach(productId => {
				if (productId !== null) {
					const product = state.productStore.data.productList[productId];
					if (product){
						baseProductList.push(product);
					}
					
				}
			});

			meta.origin.push("Year")

			// annars om vi har en mc satt 
		} else if (state.searchProductConfig.mc && state.searchProductConfig.mc.mcId > 0) {

			const mc = state.searchProductConfig.mc;

			productIdList = mc.productList;

			mc.yearList.forEach(year => {
				if (year !== null && year.productList && year.productList.length > 0) {
					productIdList = productIdList.concat(year.productList);
				}
			});

			baseProductList = this.productIdListToProductList(productIdList, state);

			meta.origin.push("Mc-modell");

			// eller om vi har en tillverkare satt 
		} else if (state.searchProductConfig.brand && state.searchProductConfig.brand.id > 0){

			
			const brand = state.searchProductConfig.brand;

			productIdList = [];

			brand.modelList.forEach(model => {

				if (model !== null) {
					
					console.log('FP: search: model: ', model.modelName);
					

					productIdList = productIdList.concat(model.productList);


					model.yearList.forEach(year => {
						if (year !== null && year.productList && year.productList.length > 0) {
							console.log('FP: search: year: ', year.year);
							productIdList = productIdList.concat(year.productList);
						}
					});
				}

			})

			baseProductList = this.productIdListToProductList(productIdList, state);
			

			meta.origin.push("Brand")
		}else{ // annars hela listan med produkter 
			baseProductList = state.productStore.data.productList.filter(product => product !== null)
			meta.origin.push("ProductList");
		}

		// om vi har en mc satt så hämta de produktId 
		const selectedMcProductIdList = this.selectedMcProductIdList(state);

		if (selectedMcProductIdList){

			const selectedMcProductIdSet = new Set(selectedMcProductIdList);

			baseProductList = baseProductList.filter(product => (product && selectedMcProductIdSet?.has(product.productId)))

		}

		// loopa listan och spara vilka manufactor som ingår i listan 
		currentSearchModel.manufactorIdInResult = [];
		baseProductList.forEach(product => {
			if (product) {

				if (!currentSearchModel.manufactorIdInResult.includes(product.manufactorId)) {
					currentSearchModel.manufactorIdInResult.push(product.manufactorId);
				}

			}
		})

		// om vi har en manufactor satt så reducera listan oavsett origin 
		if (state.searchProductConfig.manufactor && state.searchProductConfig.manufactor.manufactorId > 0) {

			baseProductList = baseProductList.filter(product => product != null && product.manufactorId == state.searchProductConfig.manufactor.manufactorId)

			meta.origin.push("Manufactor");

		} 

		// om vi har en mc-satt så addera universal-produkter
		if (state.searchProductConfig?.mc && (state.searchProductConfig.category == null)){

		
			console.log('FP: search storeSearchUtils: selectedMc: ', state.searchProductConfig.mc);
			var universalProductList = [];

			if (state.searchProductConfig.mc?.key?.includes("2044-aprilia")) {
				const productIdList = [141681, 129867, 129824];
				universalProductList = universalProductList.concat(this.productIdListToProductList(productIdList, state))
			}

			if (state.searchProductConfig.mc) {
				const productIdList = [99047, 141652];
				universalProductList = universalProductList.concat(this.productIdListToProductList(productIdList, state))
			}




			



			if (universalProductList && universalProductList.length > 0){ // lägg till tillverare i listan 

				universalProductList?.filter(universalProduct => universalProduct != null)?.forEach(universalProduct => {
					if (!currentSearchModel.manufactorIdInResult.includes(universalProduct.manufactorId)) {
						currentSearchModel.manufactorIdInResult.push(universalProduct.manufactorId);
					}
				})

				// om vi har en manufactor satt så filtera bort alla andra 
				if (state.searchProductConfig.manufactor && state.searchProductConfig.manufactor.manufactorId > 0) {

					universalProductList = universalProductList.filter(universalProduct => universalProduct != null && universalProduct.manufactorId == state.searchProductConfig.manufactor.manufactorId)

				} 
				
				universalProductList = universalProductList.filter(universalProduct => universalProduct != null);

				baseProductList = baseProductList.concat(universalProductList)
			}
			
		}

		// filtrera produktlistan utifrån productType, matcha produktens pt mot vald pt för siten. 
		if (state.productTypeModel.selected){

			const pt = state.productTypeModel?.selected?.pt

			if (pt == 3){


				const manufactorIdList3 = [];

				state.baseModel?.manufactorList?.filter(manufactor => manufactor && manufactor.pt == 3).forEach(manufactor => {
					const manufactorId = manufactor.manufactorId
					manufactorIdList3[manufactorId] = true;
				})

				console.log('FP: manufactorIdList3: ', manufactorIdList3);
				

				baseProductList = baseProductList.filter(product => product != null && (product.pt == pt || manufactorIdList3[product.manufactorId])) 
				meta.origin.push("PT3: " + state.productTypeModel?.selected?.name)

			}else{

				baseProductList = baseProductList.filter(product => product != null && product.pt == pt) 
				meta.origin.push("PT: " + state.productTypeModel?.selected?.name)

			}

			
		}

		console.log('FP: search rebuildSearchModel(), före baseProductList ', performance.now() - start2);

		// här bygger vi listan med sökbara produkter och vilka properties som ska vara sökbara
		if (baseProductList){

			//baseProductList.forEach(product => {
				const end = baseProductList.length
				var chunkSize = 5000;

				for(let i = 0; i < end; i++){


					

					const product = baseProductList[i];

						// FP: S2
						if (product != null && product.search2){
							product.search2.search = {} // nollställer current search
							currentSearchModel.productList.push(product.search2);
							continue;
					
						}

						if (product != null){

							if (i && i % (chunkSize) === 0) {
								await new Promise((r) => setTimeout(r, 0));
							}
	
							product.score = 0; // FP: 2026 

							//var importantKeywords = [];
							let productKeywordListFromServer = state.searchIndexModel?.productIdListKeywordList?.[String(product.productId)];

							var keywords = productKeywordListFromServer ?? [];
							//var keywords = [];

							//importantKeywords.push("PID:" + String(product.productId));
							keywords = this.keywordsPush(keywords, this.createKeyword("pid:" + String(product.productId), 1000, "ProductId"))

							// artnr
							const artnr = product.artnr.replace(/[^A-Za-z0-9._-]/g, "") // artnr tillåter ._-

							
							if (artnr) {
								//keywords = this.keywordsPush(keywords, artnr);
								//importantKeywords.push(artnr)
								keywords = this.keywordsPush(keywords, this.createKeyword(artnr, 100, "Artikelnummer 1"))
							}

							if (product?.artnr?.includes("-")){
								const artnrDash = product.artnr.replace(/[^A-Za-z0-9-]/g, "")?.replaceAll("-", " ");
								if (artnrDash){
									//keywords = this.keywordsPush(keywords, artnrDash);
									keywords = this.keywordsPush(keywords, this.createKeyword(artnrDash, 60, "Artikelnummer 2"))
								}
							}
							
							if (product?.artnr?.includes(" ")){
								const artnrSpace = product.artnr.replace(/[^A-Za-z0-9-]/g, "")?.replaceAll(" ", "-");
								if (artnrSpace){
									//keywords = this.keywordsPush(keywords, artnrSpace);
									keywords = this.keywordsPush(keywords, this.createKeyword(artnrSpace, 60, "Artikelnummer 3"))
								}
							}

							// productName
							var productName = null;

							if (product.name){

								productName = product.name.toLowerCase()
								const manufacturerName = (product.manufactorName || '').toLowerCase()

								const productParts = productName.replace(/[^a-zåäö0-9]+/g, '-').split('-')
								const manufacturerParts = manufacturerName.replace(/[^a-zåäö00-9]+/g, '-').split('-')

								// Ta bort manufacturer ord-för-ord från början
								let i = 0
								while (
									i < manufacturerParts.length &&
									productParts[i] === manufacturerParts[i]
								) {
									i++
								}

								const cleanedParts = productParts.slice(i)

								productName = cleanedParts.join(' ')
								const cleanedNameCompact = cleanedParts.join('')

								if (productName) {
									keywords = this.keywordsPush(keywords, this.createKeyword(productName, 50, "Benämning 1", true))
								}

								if (cleanedNameCompact) {
									keywords = this.keywordsPush(keywords, this.createKeyword(cleanedNameCompact, 30, "Benämning 2", true))
								}
							}

							

							// första och andra  ordet i benämningen
							if (productName){
						

								const parts = productName.split(' ')

								const firstWord = parts[0]
								const secondWord = parts[1]

								if (firstWord) {
									keywords = this.keywordsPush(keywords, this.createKeyword(firstWord, 30, "Benämning[0]"))
								}
								if (secondWord) {
									keywords = this.keywordsPush(keywords, this.createKeyword(secondWord, 20, "Benämning[1]"))
								}

							}
							
							// ean
							if (product?.ean){
								//importantKeywords.push(product.ean);
								keywords = this.keywordsPush(keywords, this.createKeyword(product.ean, 100, "EAN"))
							}

							// manufactor
							if (product.manufactorName){
								//keywords = this.keywordsPush(keywords, product.manufactorName)
								keywords = this.keywordsPush(keywords, this.createKeyword(product.manufactorName, 50, "manufactorName"))

								const firstToken = product.manufactorName?.toLowerCase()?.split(/[^a-zåäö00-9]+/)[0]

								if (firstToken && firstToken !== product.manufactorName) {
									keywords = this.keywordsPush(keywords, this.createKeyword(firstToken, 30, "manufactorName-first"))
								}


							}
							
							//  product.keywords
							if (product?.keywords){

								// om den innehåller komma, 
								if (product?.keywords?.includes(",")){
									product.keywords?.trim().split(",").forEach((phrase) => {

										if (phrase && phrase.length >= 2){
											//importantKeywords.push(phrase.trim());
											keywords = this.keywordsPush(keywords, this.createKeyword(phrase.trim(), 100, "Produkt-keywords 1"))
										}

										
									});
								}else{
									//importantKeywords.push(product.keywords); // FP: lägger in hela strängen som den är. 
									keywords = this.keywordsPush(keywords, this.createKeyword(product.keywords, 100, "Produkt-keywords 2"))
								}

								
							}

							// productOption eanList
							if (product?.productOptionData?.eanList){
								//keywords = this.keywordsPush(keywords, product?.productOptionData?.eanList)
								keywords = this.keywordsPush(keywords, this.createKeyword(product?.productOptionData?.eanList, 60, "eanList"))
							}

							// productOption artnrList
							if (product?.productOptionData?.artnrList){
								//keywords = this.keywordsPush(keywords, product?.productOptionData?.artnrList)
								keywords = this.keywordsPush(keywords, this.createKeyword(product?.productOptionData?.artnrList, 60, "artnrList"))
							}

							var bonus = 0;

							if (product.price2 > 0){
								bonus = 10;

							}

							if (product.noInStockKey == "LOW_STOCK"){
								bonus += 5;
							}

							if (product.noInStockKey == "IN_STOCK") {
								bonus += 10;
							}



							//currentSearchModel.productList.push(this.getProduct(product.productId, importantKeywords, keywords, "", bonus))
							const search = this.getProduct(product.productId, keywords, bonus);
							currentSearchModel.productList.push(search);

							// FP: S2 sätter också objektet på produkten
							product.search2 = search
						}

						
			//})
					}
		}


		//console.log('FP: search rebuildSearchModel(), CO2: done', currentSearchModel);
		console.log('FP: search rebuildSearchModel(), CO2: done count:', currentSearchModel.productList?.length);

		const millis = Date.now() - start;

		currentSearchModel.meta.elapsed = (millis / 1000)

		//const end = performance.now();
		//const duration = performance.now() - start2;

		//alert("Rebuild " + duration.toFixed(2) + " ms");
		console.log('FP: search rebuildSearchModel(), CO2: rebuild complete in: ', performance.now() - start2);
		

		return currentSearchModel

	},

	selectedMcProductIdList(state){ // FP: 2026 skapar en så liten lista av produkter till vald mc det går

		var productIdList = [];

		if (state.searchProductConfig.year && state.searchProductConfig.year.year != "") {

			return state.searchProductConfig.year.productList?.filter(productId => productId !== null);


			// annars om vi har en mc satt 
		} else if (state.searchProductConfig.mc && state.searchProductConfig.mc.mcId > 0) {

			const mc = state.searchProductConfig.mc;

			productIdList = mc.productList;

			mc.yearList.forEach(year => {
				if (year !== null && year.productList && year.productList.length > 0) {
					productIdList = productIdList.concat(year.productList);
				}
			});

			return productIdList;

			// eller om vi har en tillverkare satt 
		} else if (state.searchProductConfig.brand && state.searchProductConfig.brand.id > 0) {


			const brand = state.searchProductConfig.brand;

			productIdList = [];

			brand.modelList.forEach(model => {

				if (model !== null) {

					console.log('FP: search: model: ', model.modelName);


					productIdList = productIdList.concat(model.productList);


					model.yearList.forEach(year => {
						if (year !== null && year.productList && year.productList.length > 0) {
							console.log('FP: search: year: ', year.year);
							productIdList = productIdList.concat(year.productList);
						}
					});
				}

			});

			return productIdList;

		}
		return null;

	},

	keywordsPush(keywords, keyword){
		
		if (keyword){
			keywords.push(keyword)
		}
		
		return keywords;
	},

	// gör om listan av productId till en lista av riktiga produkterna. 
	productIdListToProductList(productIdList, state){

		var indexProductIdList = []; // rensa ut dubletterna 

		var productList = [];

		productIdList.forEach(productId => {
			indexProductIdList[productId] = productId;
		})


		indexProductIdList.forEach(productId => {
			if (productId !== null) {
				const product = state.productStore.data.productList[productId];
				if(product){
					productList.push(product);
				}
				
			}
		});

		return productList;

	},


	async searchProductSlow() {

		const list = ["ett", "två", "tre"];

		for (let i = 0; i < 1000000000; i++) {
			if (i && i % (1000000) === 0) {
				await new Promise((r) => setTimeout(r, 0));
			}

			list.forEach(item => {
				if (item == 666) {
					//
				}
			});

		}

		return 100;

	},

	searchProductSlowX() {

		return new Promise((resolve) => {

			var i = 0;
			for (; i <= 10000000000; i++) {

				//
			}

			resolve(i);


		})


	},

	async searchProductA(searchPhrase, productList) {

		var reduceList = true;
		
		const start = Date.now();

		//var productList = [];

		/*productListX.forEach(entity => {


			entity.search = { totalScore: 0, scoreList: [], showScoreList: false }
			productList[entity.entityId] = entity;

		});*/

		var resultMeta = {};

		if (searchPhrase == null || searchPhrase == ""){
			resultMeta.created = new Date().toLocaleTimeString()
			resultMeta.elapsed = 0;
			resultMeta.words = null;

			return { productList: productList, meta: resultMeta };
		}


		resultMeta.words = [];

		const countQuote = searchPhrase.length - searchPhrase.replaceAll("\"", "").length;

		if (countQuote >= 2 && countQuote % 2 == 0) {
			searchPhrase = searchPhrase.replace(/\s+(?=(?:(?:[^"]*"){2})*[^"]*"[^"]*$)/g, "*");
		}




		console.log('FP: SÖK searchPhrase: ', searchPhrase);

		// FP: 2026 nollställer alla score



		// kör igenom sökningen per ord
		const wordList = searchPhrase.trim().split(" ");

		//searchPhrase.split(" ").forEach(word => {

		for (var i = 0; i <= wordList.length; i++) {

			var word = wordList[i];

			if (!word) {
				continue;
			}

			if (word.length > 0) {

				// om order innehåller *
				word = word.replaceAll("*", " ");
				word = word.replaceAll("\"", "");

				console.log('FP: searchPrase: ', word);
				resultMeta.words.push(word);


				//const i = 0
				// listan att söka i 


				/*productList.map(entity => {

					const updatedEntity = this.appendScore(word, entity);
					entity.search = updatedEntity.search

					if (i && i % (1000) === 0) {
						//await new Promise((r) => setTimeout(r, 0));
					}


				})*/

				word = this.toLowerCaseTrim(word);

				for (var j = 0; j < productList.length; j++) {

					const entity = productList[j];

					if (entity == null) {
						continue;
					}

					if (i == 0) { // om det är första ordet
						entity.search = { totalScore: 0, scoreList: [], showScoreList: false, matchedWords: 0 }
						entity.score = 0; // FP: 2026 sätter denna till 0 initialt
					}

					const updatedEntity = this.appendScore(word, entity);
					entity.search = updatedEntity.search

					if (j && j % (1000) === 0) {
						await new Promise((r) => setTimeout(r, 0));
					}

					productList[j];


				}



			}


			// filtera listan och behåll bara de med en score, så listan bilr mindre och mindre 
			
			if(reduceList){
				productList = productList.filter(product => product.search && product.search.totalScore > 0)
			}
			



		}


		// här kör vi bonus och coverage
		for (let j = 0; j < productList.length; j++) {

			const entity = productList[j]

			if (!entity || !entity.search) {
				continue
			}

			const matched = entity.search.matchedWords
			const totalWords = wordList.length


			if (totalWords > 1) {

				const coverage = matched / totalWords

				// Skala score
				entity.search.totalScore *= coverage

				// Bonus bara om ALLA sökord matchade
				if (matched === totalWords) {
					entity.search = this.addScore(
						entity,
						100 * totalWords,
						"Coverage "
					)
				}
			}


			if (entity.bonus > 0) {
				entity.search = this.addScore(
					entity,
					entity.bonus,
					"Bonus"
				)
			}

			// uppdatera produktens scrore med totalScore
			entity.score = entity.search?.score; 

		}

		resultMeta.created = new Date().toLocaleTimeString()
		resultMeta.elapsed = (Date.now() - start) / 1000;

		// rensa bort alla med 0 i score (borde redan vara gjort)
		productList = productList.filter(entity => entity.search.totalScore > 0)
		//alert("Antal: " + productList.length)

		// sortera på score 
		// FP: 2026 productList = productList.sort((a, b) => (b.search.totalScore - a.search.totalScore))
		productList = productList.sort((a, b) => {
			
			const scoreDiff = b.score - a.score;

			if (scoreDiff !== 0) {
				return scoreDiff;
			}

			return b.productId - a.productId;
		});

		// limit till 500
		//productList = productList.slice(0, 500);

		const searchResult = { productList: productList, meta: resultMeta }
		//currentSearchResult.productList = productList

		//return Promise.resolve(searchResult)

		return searchResult;


	},

	searchProduct(state) {

		const start = Date.now();

		console.log('FP: searchProduct state: ', state);

		const currentSearchResult = state.searchProductResult;



		const searchProductConfig = state.searchProductConfig;

		var resultMeta = currentSearchResult.resultMeta;


		if (!resultMeta) {
			resultMeta = {};
		}

		resultMeta.words = [];


		var productList = [];

		// skapa en lista av produkter att söka i 
		/*searchProductConfig.productIdList.forEach(entityId => {

			const entity = state.searchModel.productList[entityId];
			entity.search = { totalScore: 0, scoreList: [], showScoreList: false }
			productList[entityId] = entity;

		});*/


		// sök i alla
		state.searchModel.productList.forEach(entity => {


			entity.search = { totalScore: 0, scoreList: [], showScoreList: false }
			productList[entity.entityId] = entity;

		});



		// kör igenom sökningen per ord
		searchProductConfig.searchPhrase.split(" ").forEach(word => {

			if (word.length > 0) {
				console.log('FP: searchPrase: ', word);
				resultMeta.words.push(word);


				// listan att söka i 
				/*productList.map(entity => {

					const updatedEntity = this.appendScore(word, entity);
					entity.search = updatedEntity.search

				})*/

				productList.forEach(entity => {
					if (entity.search.totalScore > 0 && entity.bonus > 0) {
						entity.search = this.addScore(entity, entity.bonus, "Add bonus score")
					}
				})

			}

			// filtera listan och behåll bara de med en score. 
			productList = productList.filter(product => product.search && product.search.totalScore > 0)



		})

		resultMeta.created = new Date().toLocaleTimeString()
		resultMeta.elapsed = (Date.now() - start) / 1000;

		currentSearchResult.meta = resultMeta


		// rensa bort alla med 0 i score
		productList = productList.filter(entity => entity.search.totalScore > 0)

		// sortera på score och limitera till 500
		//productList = productList.sort((a, b) => (a.search.totalScore < b.search.totalScore))
		//productList = productList.sort((a, b) => (b.search.totalScore - a.search.totalScore)) // FP: SORT 
		productList = productList.sort((a, b) => {

			// 1. Sortera på totalScore (desc)
			const scoreDiff = b.search.totalScore - a.search.totalScore;
			if (scoreDiff !== 0){
				return scoreDiff;
			}

			// 2. Om lika score → sortera på productId (desc)
			return b.productId - a.productId;
		});

		// limit till 500
		productList = productList.slice(0, 500);


		currentSearchResult.productList = productList

		return currentSearchResult



	},

	appendScore(searchWord, entity) { // lägger till en score till en entity


		/*
		const important = entity.importantKeywords.join(" ").toLowerCase();
	
		if (important.includes(searchWord.toLowerCase())) {
			entity.search = this.addScore(entity, 10, "Test träff på important:" + important + ": searchWord:" + searchWord + ":");
		} else {
			entity.search = this.addScore(entity, 1, "Ingen träff på important:" + important + ": searchWord:" + searchWord + ":");
		}*/

		//console.log('FP: important', important);


		// important
		//const lengthScore = searchWord.length


		
		// FP: 2026, körs inte längre
		/*entity.importantKeywords.forEach(importantKeyword => {

			//console.log('FP: log: importantKeyword: ', importantKeyword);
			
			if (this.fullMatch(importantKeyword, searchWord)) {
				entity.search = this.addScore(entity, (120 + (10 * lengthScore)), "Full träff på important:" + importantKeyword + ": searchWord:" + searchWord + ":"); // addera längden på ordet
				return entity;
			} 


			if (this.partialMatch(importantKeyword, searchWord)) {
				entity.search = this.addScore(entity, (50 + (5 * lengthScore)), "Delvis träff på important:" + importantKeyword + ": searchWord:" + searchWord + ":");
				return entity

			}

			
			if (this.reversedPartialMatch(importantKeyword, searchWord)) {
				entity.search = this.addScore(entity, (20 + (3 * lengthScore)), "Omvänd delvis träff på important:" + importantKeyword + ": searchWord:" + searchWord + ":");
				return entity
			}


			

		})*/

		//console.log('FP: entity:', entity);
		

		var match = false;

		for (const keywordObject of entity.keywords) {
		//entity.keywords.forEach(keywordObject => {

			

			const keyword = keywordObject.keyword // kan göras när den skapas! 
			const score = keywordObject.score
			const label = keywordObject.label
			const multiple = keywordObject.multiple

			const lengthScore = (searchWord.length / keyword.length) + 1
			//console.log('FP: entity: keyword', keyword);

			// var match = false;


			if (keyword.startsWith("pid:")){
				if (keyword === searchWord){
					entity.search = this.addScore(entity, ((score * 3) + (10 * lengthScore)), "Full träff på pid:" + keyword + ": searchWord:" + searchWord + ": " + label); // addera längden på ordet
					break
				}

				continue
				//entity.search.matchedWords++
				//return entity;
				
			}

			else if (this.fullMatch(keyword, searchWord)) {
			
				entity.search = this.addScore(entity, ((score * 4) + (10 * lengthScore)), "Full träff på keyword:" + keyword + ": searchWord:" + searchWord + ": " + label); // addera längden på ordet
				match = true
				//return entity;
				//break;
			}

			else if (this.prefixMatch(keyword, searchWord)) {
				
				entity.search = this.addScore(entity, ((score * 0.6) + (3 * lengthScore)), "Prefix träff på keyword:" + keyword + ": searchWord:" + searchWord + ":" + label);
				match = true
				//return entity;
				//break;
			}

			else if (this.partialMatch(keyword, searchWord)) {
				entity.search = this.addScore(entity, ((score * 0.4)+ (3 * lengthScore)), "Delvis träff på keyword:" + keyword + ": searchWord:" + searchWord + ":" + label);

				if (multiple){ // om det blir flera träffar i keyword och keyword tillåter detta

					const regex = new RegExp(searchWord, "g")
					var matches = (keyword.match(regex) || []).length

					const adjustedScore = ((score * 0.2) + (3 * lengthScore)) * matches
					entity.search = this.addScore(entity, adjustedScore, "Delvis träff på keyword multiple-match (" + matches + "):" + keyword + ": searchWord:" + searchWord + ":" + label);


				}
				
				match = true
				//return entity;
				//break;
			}

			else if (this.reversedPartialMatch(keyword, searchWord)) {
				entity.search = this.addScore(entity, ((score * 0.3) + (3 * lengthScore)), "Omvänd delvis träff på keyword:" + keyword + ": searchWord:" + searchWord + ":" + label);
				match = true
				//return entity;
				//break;
			}




			/*if (this.fullMatch(keyword, searchWord)) {
				entity.search = this.addScore(entity, (80 + (10 * lengthScore)), "Full träff på keyword:" + keyword + ": searchWord:" + searchWord + ":"); // addera längden på ordet
				return entity;
			}

			if (this.partialMatch(keyword, searchWord)) {
				entity.search = this.addScore(entity, (20 + (3 * lengthScore)), "Delvis träff på keyword:" + keyword + ": searchWord:" + searchWord + ":");
				return entity;
			}

			if (this.reversedPartialMatch(keyword, searchWord)) {
				entity.search = this.addScore(entity, (10 + (3 * lengthScore)), "Omvänd delvis träff på keyword:" + keyword + ": searchWord:" + searchWord + ":");
				return entity;
			}*/



		}

		if (match == true) {
			entity.search.matchedWords++
		}

		// keywords FP: 2026, körs inte längre
		/*entity.keywords.forEach(keyword => {


			if (this.fullMatch(keyword, searchWord)) {
				entity.search = this.addScore(entity, (80 + (10 * lengthScore)), "Full träff på keyword:" + keyword + ": searchWord:" + searchWord + ":"); // addera längden på ordet
				return entity;
			}

			if (this.partialMatch(keyword, searchWord)) {
				entity.search = this.addScore(entity, (20 + (3 * lengthScore)), "Delvis träff på keyword:" + keyword + ": searchWord:" + searchWord + ":");
				return entity;
			}

			if (this.reversedPartialMatch(keyword, searchWord)) {
				entity.search = this.addScore(entity, (10 + (3 * lengthScore)), "Omvänd delvis träff på keyword:" + keyword + ": searchWord:" + searchWord + ":");
				return entity;
			}



		})*/

		// text

		/* FP 2026 tog bort denna för att testa sökningens hastight
		if (entity.text && entity.text.length > 0) {

			const diff = entity.text.toLowerCase().length - entity.text.toLowerCase().replaceAll(searchWord.toLowerCase(), "").length;

			if (diff > 0) {
				entity.search = this.addScore(entity, (5 * diff), "Textsökning: " + entity.text.substring(0, 100) + ": searchWord:" + searchWord + ": diff: " + diff);
			} else {
				entity.search = this.addScore(entity, 1, "Textsökning: " + entity.text.substring(0, 100) + ": searchWord:" + searchWord + ": ingen träff");
			}

		}*/


		/*if (entity.bonus > 0) {
			entity.search = this.addScore(entity, entity.bonus, "Add bonus score")
		}*/


		return entity

	},

	toLowerCaseTrim(str){
		//return str
		
		return str?.toLowerCase()?.trim();

	},

	addScore(entity, score, description) {

		score = Math.round(score);

		entity.search.totalScore += score

		if (score > 0) {
			entity.search.scoreList.push({ score: score, description: description })
		}


		return entity.search;
	},

	fullMatch(word, searchWord) {

		return (word == searchWord)
		//return (word.toLowerCase().trim() == searchWord.toLowerCase().trim())

	},

	partialMatch(word, searchWord) {
		return word.includes(searchWord)
	},

	prefixMatch(word, searchWord) {
		return word.startsWith(searchWord)
	},

	reversedPartialMatch(word, searchWord) {
		return searchWord.includes(word)
	},

	/*
	partialMatch(word, searchWord) {


		if (!word){
			return false;
		}

		if (word.toLowerCase().trim().includes(searchWord.toLowerCase().trim())){ // om vi har en match
			return true;
		}

		//const searchWordTrimmed = searchWord.replace(/[^A-Za-z0-9]/g, "")
		word = word.replace(/[^A-Öa-ö0-9]/g, ""); // tar bort allt utom a-ö ur produktens sökord

		if (word.toLowerCase().trim().includes(searchWord.toLowerCase().trim())){ 
			return true;
		}

		return false;

	},*/

	/*reversedPartialMatch(word, searchWord) {
		return searchWord.toLowerCase().trim().includes(word.toLowerCase().trim())
	},*/

	createKeyword(keyword, score, label, multiple = false){

		if (!keyword || keyword.length < 2){
			return null;
		} 

		return ({ keyword: this.toLowerCaseTrim(keyword), score: score, label: label, multiple: multiple })

	},

	getProduct(entityId, keywords, bonus){
		return { entityId: entityId, importantKeywords: [], keywords: keywords, bonus: bonus, search: {}, totalScore: 0 }
	},

	// här läggs sökdata in på den sökbara entiteten
	/*getProduct(entityId, importantKeywords, keywords, text, bonus) {

		return { entityId: entityId, importantKeywords: importantKeywords, keywords: keywords, text: text, bonus: bonus, search: {}, totalScore: 0 }

	},*/

	getCategoryModel(baseModel, productTypeModel) {

		if (productTypeModel?.selected?.key == "mc") {

			//return baseModel?.categoryModel2.mc
			return baseModel?.categoryModel.mc
			
		}

		if (productTypeModel?.selected?.key == "bike") {

			//return baseModel?.categoryModel2.bike
			return baseModel?.categoryModel.bike

		}

		if (productTypeModel?.selected?.key == "oil") {

			//return baseModel?.categoryModel2.oil
			return baseModel?.categoryModel.oil

		}
		
		//return baseModel?.categoryModel2
		return baseModel?.categoryModel

	},

	getManufactorList(baseModel, productTypeModel){

		if (productTypeModel && productTypeModel.selected){
			return baseModel?.manufactorList?.filter(manufactor => manufactor != null && manufactor.pt == productTypeModel.selected.pt)
		}

		return baseModel?.manufactorList?.filter(manufactor => manufactor != null);
	},
	
	excludeProductFromResult(product, searchProductConfig){
		if (product && searchProductConfig){
			//
		}

		if (searchProductConfig?.filter?.onlyInStock){

			if (product?.noInStockKey == "OUT_OF_STOCK" && !product?.productOptionData) {
				return true;
			}

			if (product?.productOptionData?.noInStockKey == "OUT_OF_STOCK") {
				return true;
			}
			
		}

		

		return false;
	}



}

export default searchUtil
